import {SET_REPORTS, CLEAR_REPORTS} from "./types";

export const reportsReducer = (state = null, action) => {
    switch (action.type) {
        case SET_REPORTS: return action.reports;
        case CLEAR_REPORTS: return null;
        default: return state
    }
}